whenAvailable('$', function() {
$(function(){
    function navFeatures() {
        nav = $('#nav_features');
        
        const windowWidth = $(window).width();
        if (windowWidth <= 768) {
            if ( $(window).scrollTop() >= 500 && !nav.hasClass('active') ) {
                nav.addClass('active').stop().slideDown();
            } else if ( $(window).scrollTop() < 500 && nav.hasClass('active') ) {
                nav.removeClass('active').stop().slideUp();
            }
        } else {
            if ( $(window).scrollTop() >= 200 && !nav.hasClass('active') ) {
                nav.addClass('active').stop().slideDown();
            } else if ( $(window).scrollTop() < 200 && nav.hasClass('active') ) {
                nav.removeClass('active').stop().slideUp();
            }
        }
    }

    function debounce(func, wait) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };
    }  

    const handleScroll = debounce(function () {
        navFeatures()
    }, 100);

    $(window).scroll(function(e){ handleScroll(); });
    navFeatures();

    // Custom trigger for splash animation
    // https://stackoverflow.com/questions/21561480/trigger-event-when-user-scroll-to-specific-element-with-jquery
    var buffer = 5;
    var activation_offset = 0.75; //determines how far up the the page the element needs to be before triggering the function
    var element_position, screen_height, activation_point, max_scroll_height;

    function updateElemPos() {
        element_position = $('#trigger').offset().top;
        screen_height = $(window).height();
        activation_point = element_position - (screen_height * activation_offset);
        max_scroll_height = $('body').height() - screen_height - buffer;
    }

    // Does something when user scrolls to it OR when user has reached the bottom of the page and hasn't triggered the function yet
    function checkElemPos() {
        var y_scroll_pos = window.pageYOffset;
        var element_in_view = y_scroll_pos > activation_point;
        var has_reached_bottom_of_page = max_scroll_height <= y_scroll_pos && !element_in_view;

        if(element_in_view || has_reached_bottom_of_page) {
            if (!$('.splash-chair-main').hasClass('animate')) {
                $('.splash-chair-main').addClass('animate');
                setTimeout(function(){ $('.splash-chair-left, .splash-chair-right').addClass('animate'); }, 200);
            }
        } else {
            if ($('.splash-chair-main').hasClass('animate')) {
                $('.splash-chair').removeClass('animate');
            }
        }
    }

    // Initialize after page loads
    setTimeout(function(){
        // Set delay to add class to splash chair images to prevent animation from showing on page load
        $('.splash-chair').addClass('loaded');

        updateElemPos();
        checkElemPos();
    }, 500);

    $(window).on('scroll resize', function(e) {
        // Update on resize
        if (e.type == 'resize') { updateElemPos(); }
        checkElemPos();
    });

    whenAvailable('slick',function() {
        $('.ergo-slick')?.slick({
            infinite: false,
            dots: false,
            arrows: false,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        centerMode: true,
                        centerPadding: '80px',
                        slidesToShow: 1,
                        arrows: true
                    }
                },
                {
                    breakpoint: 425,
                    settings: {
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        arrows: true
                    }
                }
            ]
        });
    });
});
});